// extracted by mini-css-extract-plugin
export default {"modal":"fllU0JSvmoQQ1JWaXSif","content":"BVj85rg9Z0CP374rMGB_"};